import {Button} from 'primereact/button'
import {Dialog} from 'primereact/dialog'
import {forwardRef, useImperativeHandle, useState} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'

const DialogWrapper = forwardRef(
    ({children, header = '', onSubmit = () => {}}, ref) => {
        useImperativeHandle(ref, () => ({
            onShow: handleOnShowForm,
            onHide: handleOnHideForm,
        }))
        const {translateCommons} = TranslateUtils()
        const [visible, setVisible] = useState(false)
        const handleOnShowForm = () => {
            setVisible(true)
            blockOverflownScroll()
        }

        const handleOnHideForm = () => {
            setVisible(false)
            unblockOverflownScroll()
        }
        return (
            <Dialog
                visible={visible}
                onHide={() => {
                    handleOnHideForm()
                }}
                blockScroll={true}
                header={header}
                style={{minWidth: '50rem'}}>
                <div className="mb-5">{children}</div>

                <Button
                    label={translateCommons('SUBMIT')}
                    icon="pi pi-send"
                    className="col-12 p-button-lg font-bold"
                    onClick={() => {
                        onSubmit()
                        setVisible(false)
                    }}
                />
            </Dialog>
        )
    },
)

export default DialogWrapper
